var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTrophy48Line = function SvgIconTrophy48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 12.3h-3.1v-.1c0-1.6-1.3-2.9-2.9-2.9H17.2c-1.6 0-2.9 1.3-2.9 2.9v.1h-3.1c-1.6 0-2.9 1.3-2.9 2.9v3.2c0 2.92 2.38 5.3 5.3 5.3h.86a9.704 9.704 0 0 0 7.84 7.84v3.76H17v3.4h14v-3.4h-5.3v-3.76a9.704 9.704 0 0 0 7.84-7.84h.86c2.92 0 5.3-2.38 5.3-5.3v-3.2c0-1.6-1.3-2.9-2.9-2.9Zm-25.1 6.1v-2.7h2.6v4.6h-.7a1.9 1.9 0 0 1-1.9-1.9ZM24 28.3c-3.47 0-6.3-2.83-6.3-6.3v-9.3h12.6V22c0 3.47-2.83 6.3-6.3 6.3Zm12.3-9.9a1.9 1.9 0 0 1-1.9 1.9h-.7v-4.6h2.6v2.7Z",
    fill: "current"
  })));
};
export default SvgIconTrophy48Line;